<script>
  import Portal from 'svelte-portal'
  import { urls, getCookie } from './config.js';
  import en from '../strings.en';
  import fr from '../strings.fr';
  export let lang, dataset;
  export let urlConfig;

  const { kiboUrl, decoupledUrl } = urlConfig;

  // export let userData;
  let strings = en;
  if (lang == 'fr') {
    strings = fr;
  }
  let _strings = strings.strings;

  let imgsata = urls.svgBucket;
  let account = false;
  let login = false;
  let panelIsOpen = false
  let trigger;
  let storeSceneEnabled = false;
  //loyalty incognito flags
	let useLoyaltyService = dataset.useLoyaltyService || "false"
	let displayLoyaltyToEndUser = dataset.displayLoyaltyToEndUser || "false"
	let showLoyaltyService = false;


	let currentUrl = window.location.href;
    let hasLogin = '/login';
    let returnUrl = '';

    if (currentUrl.includes(hasLogin)) {
        returnUrl = '';
    } else {
		returnUrl = `?returnurl=${currentUrl}`;
	}

  //Function to check the incognito flags and show loyalty features to end user. Implemented for incognito testing.
	const checkIncognitoFlags = () => {
		if(useLoyaltyService == "true" && displayLoyaltyToEndUser == "true") {
			showLoyaltyService = true;
		}	else if(useLoyaltyService =="true" && displayLoyaltyToEndUser == "false") {
			var url = window.location.search;
			const urlParams = new URLSearchParams(url);
			const showLoyalty = urlParams.get('showLoyalty');
			if(showLoyalty == "true") {
				showLoyaltyService = true;
			}
		}
	}
  checkIncognitoFlags();

  const openPanel = () => {
    panelIsOpen = true;
  }

  const closePanel = () => {
    panelIsOpen = false;
  }

  function main() {
    //Get cookie data for user
    let userCookie = getCookie('user');
    if (userCookie) {
      let userData = JSON.parse(userCookie);
      if (
        userData &&
        (userData.isAnonymous === 'false' || userData.isAnonymous === false)
      ) {
        account = true;
      }
    }
  }

  main();

  async function getStoreSceneAttributeValue(){

    storeSceneEnabled = window.preferredStore?.attributes?.['store-scene-enabled'] == true

  }

getStoreSceneAttributeValue();

  const signout = () => {
    // window.localStorage.removeItem("userid");
    account = false;
    document.cookie = `user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${window.location.hostname.replace('www','')}; path=/;`;
    document.cookie = `userId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${window.location.hostname.replace('www','')}; path=/`;

    //Remove Wishlist data in localStorage
    window.localStorage.removeItem('wishlistProducts');
    //Remove cartSummary data in localStorage
    window.localStorage.removeItem('hh_cart_summary');

    window.location.href = `${decoupledUrl}/_api/${lang}/user/logout`;
  };

  const getAccount = async () => {
    try {
      // let response = await fetch(`${decoupledUrl}/_data/${lang}/login`, {
      let response = await fetch(`/_data/${lang}/login`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'no-cors'
        // data: JSON.stringify({
        // 	username: "nithin.j@ignitiv.com",
        // 	password: "Matekk@2010",
        // }),
      });
      let json = await response.json();
      // console.log("sata", json);
      if (json.userId) {
        localStorage.setItem('userid', json.userId);
        document.cookie = 'userid=' + json.userId;
        account = true;
      }
    } catch (error) {
      account = false;
      console.log(error);
    }
  };


  window.addEventListener('hhPanelClose', closePanel, false)
  window.addEventListener('hhSignOut', signout, false)
  window.addEventListener('signupSuccess', main);

  window.addEventListener('popstate', closePanel, false);

  $: document.querySelector('hh-panel').hidden = !panelIsOpen



</script>


{#if account === true}
  <a
    bind:this={trigger}
    href="/{lang}/customer/login"
    on:click|preventDefault={openPanel}
  >
    <img
      src="{urls.svgBucket}/icon.account.svg"
      alt={_strings.myAccountAlt}
      class="icon"
      width="0"
      height="0"
    />
    {_strings.account}
  </a>
{:else}
	<a href={`/${lang}/customer/login${returnUrl}`}>
    <img
      src="{urls.svgBucket}/icon.account.svg"
      alt={_strings.loginAlt}
      class="icon"
      width="0"
      height="0"
    />
    {_strings.login}
  </a>
{/if}

{#if panelIsOpen}
<Portal target='hh-panel'>
	<header>
		<a class="h3" id="dc-account-link" href="/{lang}/customer/myaccount#/my-account"><img src="{urls.svgBucket}/icon-vector.svg" alt="My Account" height="20px" width="20px" class="Icon Bigger" />{_strings.myAccount}</a>
		<button class="Button ButtonGhost" on:click|preventDefault={closePanel}>{_strings.closeBtn}</button>
	</header>
  <hr data-no-padding/>
  <div class="dc-account-links">
    <p>
      <a
        id="dc-account-link"
        href="/{lang}/customer/myaccount#/my-account"
        >{_strings.myProfile}</a
      >
    </p>
    <p>
      <a
        id="dc-account-link"
        href="/{lang}/customer/myaccount#/order-history"
        >{_strings.orderHistory}</a
      >
    </p>
    <p>
      <a
        id="dc-account-link"
        href="/{lang}/customer/myaccount#/return-history"
        >{_strings.returnHistory}</a
      >
    </p>
    {#if showLoyaltyService && storeSceneEnabled}
      <p>
        <a
          id="dc-account-link"
          href="/{lang}/customer/myaccount#/scene"
          >{_strings.scenePlustext}</a
        >
      </p>
    {/if}
    <p>
      <a
        id="dc-account-link"
        href="/{lang}/customer/myaccount#/communication-preferences"
        >{_strings.communicationPreferences}</a
      >
    </p>
    <p>
      <a
        id="dc-account-link"
        href="/{lang}/customer/myaccount#/wishlist"
        >{_strings.wishlist}</a
      >
    </p>
    <p>
      <a
        id="dc-account-link"
        href={`${decoupledUrl}/_api/${lang}/user/logout`}
        on:click|preventDefault={signout}
      >{_strings.signOut}</a
      >
    </p>    
  </div>
</Portal>
{/if}

<style>
	#dc-account-link {
		color: black;
	}
	#dc-account-link:hover {
		text-decoration: 0.25px underline;
	}
	/* .dc-my-account {
		padding: 10px 0px 20px 0px;
		display: flex;
		margin-left: 1.125em;
		align-items: center;
	} */
	/* .dc-my-account > a {
		margin-left: calc(var(--gap) / 2);
	} */
	.dc-account-links {
		margin-left: 1.625em;
		line-height: 1.5em;
	}
	hr {
		margin: 0 !important;
	}
	/* .Button.ButtonGhost{
		color: #d9d9d9;
	} */
</style>
